export const lang = {
  BarOther: {
    home: '首页',
    service: '服务',
    quality: '质量品控',
    rkkw9t: '集装箱监装',
    oww1lo: '供应商评估',
    vwiq99: '新产品开发',
    fuaoau: '用户指引',
    q618ep: '联系我们',
    iqp9rr: '登录',
    b2xprb: '切换语言',
  },
  FooterOther: {
    zs3eck: '微信扫码预约服务',
    ktb2ur: 'Minder Inspection',
    '6yyjjc': 'Works with Minder, Minder Works',
    re5sad: '曼德品控',
    usnxbi: '联系我们',
  },
  main: {
    '1dt1j2': '质量无小事，曼德来守护',
    quailty: '曼德提供可靠的质量品控服务，供应商评估服务',
    pczd9p: '登录',
    '7rbwz7':
      '曼德品控是一家互联网+品控的第三方检测服务平台，曼德提供验货、监装、验厂、供应商评估，新产品开发等一系列质量品控服务。将互联网信息技术与传统检测服务相结合，通过智能化平台系统为不同领域的客户提供跨区域的，高效专业的服务，为海内外所有贸易商伙伴创造更高价值。',
    d5ccl3: '品质服务',
    hb3x95:
      '曼德以一种全新的方式来追踪质量控制流程，凭借优质的服务体验让用户更高效，更方便的掌控质检流程，并最终提升整体竞争力。',
    ss10g8: '质量品控服务',
    jspb3m: '更多',
    u44avv: '供应商评估',
    cpnavt: '集装箱监装',
    xf74pb: '新产品开发',
    qlu4ej: '核心价值',
    '1bfizf': '专业品控团队',
    me37mm:
      '曼德拥有专业品控团队，品控人员来自国际知名贸易集团，第三方公正行。具备丰富的行业经验，提供优秀的品控服务。',
    cb2q1j: '跨越空间屏障，不受时间束缚',
    var86x:
      '不再担心异地出差的路途劳顿，无论路途再远，时间再紧，无须亲自赶赴，我们帮您搞定。',
    nwz8j7: '经济高效，超高性价比',
    rto9zc: '为客户省去大笔差旅，人员费用，创造更高价值',
    wkmsf4: '数字化品控成就高品质的报告出品',
    '25f6ak':
      '我们在审查过程中重视数据收集，每一个模块都有具体数据支撑，眼见为实。 量化报告，重点清晰易读。',
    p4586r: '轻松开启曼德服务',
    jtdq0u: '登录',
    f3oiph: '登录曼德品控验货智能系统，告别繁琐流程,轻松一键预约',
    v3ojm4: '想要查看我们的输出内容？',
    b1u9xm: '接收我们的样板报告',
    okn6an: '在此输入您的邮箱',
    u5asdi: '提交',
  },
  quailty: {
    '0mal0f': '质量品控服务',
    po356y: '中期检验',
    '26c0pu':
      '在产品生产完成了30%-50%左右时对产品进行检验。主要针对产品生产细节，生产进度，技术指标等环节进行特别验视。帮助客户及时对供应商给予指导和调整。',
    '5k1ybr': '出货前检验',
    ttza9v:
      '在产品生产接近尾声或已完成时对产品进行检验。主要针对即将出货的产品品质进行检验，同时核对产品数量 ，包装细节等。为客户出货决策提供信息支持',
    okc6nf: '服务领域',
    wssl3q: '工具，玩具，家具，五金建材，饰品，日常护理品，户外用品等',
    kb9sl6: '轻工产品',
    rgkx6g: '面料，家纺，纺织品原材料等',
    d94vs5: '面料纺织品',
    qtay9t: '服装，配饰，箱包，鞋履等',
    wdw9wg: '服饰箱包',
    dq5hgi: '家用电器，电子信息设备，照明，灯具，电子配件等',
    fndilq: '电子电器',
    yovmva: '满意的不只有服务',
    h4zdms: '发起计划',
  },
  container: {
    r3687u: '集装箱监装',
    ociaza:
      '在货物完成生产，准备出货时进行装柜监督。主要针对货物数量，包装，货柜等信息进行核对。确保出货准确无误',
    qmk06r:
      '为了防范运过程中可能出现的货物损伤，曼德质检工程师会在装柜过程中引导装运人员，以更合理更安全的方式装柜',
    uhc0i8: '核心价值',
    uiovue: '确保货物装上货柜的过程中搬运妥当',
    ykb6cu: '确认装入集装箱中的产品与装箱单数据相符合，没有错装，短装',
    t76xgv: '核对产品实际包装与合同要求的相符合',
  },
  vendor: {
    '2ikbjo': '供应商评估',
    c4qsgh: '想要深入了解您的潜在供应商？',
    ja3s8r: ' 优化供应商管理系统，我们提供更好的方案！',
    zxy9bc: '清晰识别供应商',
    yewaw8:
      '多维度，深层次挖掘供应商能力 洽谈合作，运筹帷幄 细致展现真实可靠的数据， 为您的决策带来实实在在的支持',
    qnzcvs: '精耕细分市场',
    v4f2fg:
      '行业不同，从业人员所需配备的行业背要，专业知识各异。曼德精确识别细分行业，评估分析更准确',
    '2lrzjb': '高效快捷，精准决策',
    '4ez0fi':
      '基于曼德流程化的服务系统，我们以最快速度将您呈现供应商资质报告让您能够在短时间内掌握多个供应商情况，您的决策将无比准确，快速',
    '3a65tn': '主要功能',
  },
  product: {
    asifsf: '新产品开发',
    '5e2vvj':
      '新产品开发过程中通常需要与工厂开发团队保持高频次的沟通，还需要往返工厂进行技术细节的商讨，费时费力。曼德提供全流程的产品开发协助',
    '4ebm8s': '保持新品按照既定计划上市',
    gsfl38:
      '通常我们开始一个新产品开发流程时，需要进行多轮样品试制。在进行与工厂的来回沟通',
    nf0053:
      '根据买家与工厂的沟通记录，曼德工程师会实地前往工厂检查样品并记录新一轮样品的实际情况',
    csgmvo: '开发',
    ie98hv: '流程',
    a9sghc: '产品设计与原型样制作',
    zztqn9: '产品原型需要经过几轮的打磨，期间需要双方细致的沟通反馈',
    kbjhoe: '产品测试',
    jilwi4: '产品原型需要经过严格的测试，例如功性能测试，材料实验室测试等',
    urjj9c: '开模',
    '43jimm':
      '当最终的所有细节都得到确认后，一些部件需要制作特定的模具（制具）',
    hdanvk: '产前样评审',
    '5mucjv': '在很多产品开发实例中，产前样是进入大货生产前最重要的步骤',
  },
  guide: {
    '6utg29': '用户指引',
    '3proyr': '只需要简单的几步就能接入曼德订单系统',
    r9gfva: '快速接入',
  },
  FQA: {
    '1ny4sh': 'Facts &',
    '0bdyn9': 'Questions',
    juuubr: '曼德提供什么服务',
    j371ii: '订单价格如何核算？',
    m63h4i: '可以使用哪些支付方式?',
    '6a7k58': '曼德相较竞争对手有哪些优势?',
    cida7w: '支持取消订单吗？',
    wptwf3:
      '曼德品控帮助海外买家更好的控制产品品质，提供验货、监装、验厂、供应商评估，新产品开发等一系列质量品控服务',
    '3lr87o': '目前订单支付支持RMB 或 USD 双币种支付。 支持的支付方式包括：',
    '3lr8733':
      ' 1. 套餐余额 2. 支付宝扫码 3. 微信扫码 4. PayPal 5. 线下银行转账',
    xzgjmq:
      '曼德的服务价格以人/天（MD）为单位。客户在新建订单时会看到对应服务的标准单价（1MD） 。根据客户提交的订单资料，曼德会联系客户针对验货细节进行核实并对不同的订单进行报价。因而不同的订单可能会有不同的价格。',

    grrsci: '曼德品控服务相较于竞争对手，主要优势： ',
    grrsci1:
      '1. 曼德深耕制造业品控体系，通过长期的用户需求研究，对贸易商，出口商的品质痛点做出重点关注。',
    grrsci2:
      ' 2. 我们在审查过程中重视数据收集，每一个模块都有具体数据支撑，眼见为实。 量化报告，重点清晰易读。 ',
    grrsci3:
      '  3. 曼德提供优质服务的同时，保持高竞争力的价格。同时套餐客户享有折上折。',

    rni8xf:
      '支持。 在未履行服务前，客户有权取消订单。如需取消订单，请至“我的订单”中进行操作。也可联系您 的专属客户经理进行处理。',
    '68lado':
      '支持。 在未履行服务前，客户有权取消订单。如需取消订单，请至“我的订单”中进行操作。也可联系您 的专属客户经理进行处理。',
  },
  contact: {
    '44bpko': '联系我们',
    tip01: '请输入合法的邮箱',
    '8b7im3': '姓名',
    '6zh5n2': 'Email',
    ujdprn: '内容',
    aes7hy: '提交',
  },
};
